// İSG Portal — Textarea primitifi. `Input.tsx`'i BİREBİR aynalar (forwardRef, `invalid` →
// `aria-invalid`, aynı border/focus sınıfları) — tek fark `resize-y` + çok satırlı yükseklik.
//
// İlk çağıran: `apps/web-expert`'in belge şeması örnek inceleme ekranı (§7.1/§7.2, S27-D) —
// `promptGuidance` (1600 karakter) ve format notları (1200 karakter × 4) için. Üç yerde
// gerekiyor olması onu paylaşılan bir primitif yapar; yerel bir kopya bir defekttir.

import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, rows = 4, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full resize-y rounded-md border bg-surface px-3 py-2 text-sm text-fg',
        'placeholder:text-muted transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-60',
        // carbon: Input.tsx'i AYNALAR (dosya başlığı) — alt-çizgi kontrol, içe odak halkası.
        'carbon:rounded-none carbon:border-0 carbon:border-b carbon:px-4 carbon:focus-visible:ring-inset',
        'carbon:placeholder:text-placeholder',
        // `Input.tsx`'in dosya başlığı notunu AYNALAR (S33 Slice 6 global düzeltme #2).
        'carbon:[[data-tile]_&]:bg-field',
        invalid
          ? 'border-danger focus-visible:ring-danger carbon:border-b-danger'
          : 'border-border-strong carbon:border-b-border-strong',
        className,
      )}
      {...props}
    />
  );
});
